import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
import css from '../style.module.scss';
interface Params {
  wrapperRef: RefObject<HTMLDivElement | null>;
  loaderRef: RefObject<HTMLDivElement | null>;
  isPageReady: boolean;
}
export function useHeroRevealAnimations(t0) {
  const $ = _c(9);
  const {
    wrapperRef,
    loaderRef,
    isPageReady
  } = t0;
  let t1;
  if ($[0] !== isPageReady || $[1] !== loaderRef || $[2] !== wrapperRef) {
    t1 = () => {
      if (!isPageReady) {
        return;
      }
      const wrapper = wrapperRef.current;
      const loader = loaderRef.current;
      const bottom = wrapper?.querySelector(`.${css.bottomContainer}`);
      const video = wrapper?.querySelector(`.${css.videoWrapper}`);
      if (!wrapper || !loader || !bottom || !video) {
        return;
      }
      const matchMedia = gsap.matchMedia();
      matchMedia.add({
        isDesktop: "(min-width: 992px)",
        isMobile: "(max-width: 991px)"
      }, context => {
        const {
          isMobile
        } = context.conditions as gsap.Conditions;
        const gpuLayers = !isMobile;
        const tl = gsap.timeline({
          defaults: {
            ease: "power3.out",
            duration: 1.2
          }
        });
        tl.to(video, {
          scale: 1,
          force3D: gpuLayers,
          duration: 1,
          ease: "power2.out"
        }, 0).to(loader, {
          scale: 3,
          force3D: gpuLayers,
          willChange: gpuLayers ? "transform, opacity" : "auto",
          opacity: 0,
          duration: 1,
          ease: "power2.out",
          display: "none"
        }, "<").to(bottom, {
          transform: "translateY(calc(-100% - 15px))",
          force3D: gpuLayers,
          duration: 1,
          ease: "power2.out"
        }, 0.8);
      });
    };
    $[0] = isPageReady;
    $[1] = loaderRef;
    $[2] = wrapperRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isPageReady) {
    t2 = [isPageReady];
    $[4] = isPageReady;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2 || $[7] !== wrapperRef) {
    t3 = {
      scope: wrapperRef,
      dependencies: t2
    };
    $[6] = t2;
    $[7] = wrapperRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useGSAP(t1, t3);
}